import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot } from "vue"

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  buttonsList: {
    type: Array as PropType<DefaultObjectType[]>,
    default: []
  }
},
  setup(__props) {

const prop = __props;



// 控制按钮
const controlHide = (btn: any) => {
  const { controller } = btn
  return controller ? controller(btn) : true
}

const handleAction = (btn: any) => {
  const { func } = btn
  func && func(btn)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttonsList, (btn, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (controlHide(btn) && !btn.cellSlot)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, _mergeProps({ key: 0 }, btn, {
              type: btn.type || 'primary',
              onClick: ($event: any) => (handleAction(btn))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(btn.label)), 1)
              ]),
              _: 2
            }, 1040, ["type", "onClick"])), [
              [_directive_permission, btn.permissionKey]
            ])
          : _createCommentVNode("", true),
        (controlHide(btn) && btn.cellSlot)
          ? _renderSlot(_ctx.$slots, "cellSlot", _normalizeProps(_mergeProps({ key: 1 }, btn)))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}
}

})